function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useFocusEffect } from "@react-navigation/native";
import * as Sentry from "@sentry/core";
import { useCallback, useRef, useState } from "react";
import { Image, Modal, ScrollView, StyleSheet, TouchableOpacity } from "react-native";
import ImageViewer from "react-native-image-zoom-viewer";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { ActivityIndicator } from "./ActivityIndicator";
import { Button } from "./Button";
import { Icon } from "./Icon";
import { FullscreenMediaPlayer } from "./MediaPlayer";
import { Text } from "./Text";
import { View } from "./View";
import { classifyAsset } from "../lib/classifyAsset";
import { getResizedImageUrl } from "../lib/getResizedImageUrl";
var MAX_WIDTH = 170;
function ChatVideo(param) {
    var caption = param.caption, initialPositionMillis = param.initialPositionMillis, isAudio = param.isAudio, uri = param.uri, linkText = param.linkText;
    var player = useRef(null);
    var play = useCallback(function() {
        if (player.current) {
            void player.current.presentFullscreenPlayer();
        }
    }, []);
    var pause = useCallback(function() {
        if (player.current) {
            void player.current.dismissFullscreenPlayer();
        }
    }, []);
    useFocusEffect(useCallback(function() {
        return function() {
            return pause();
        };
    }, [
        pause
    ]));
    return /*#__PURE__*/ _jsx(View, {
        accessible: true,
        "aria-label": isAudio ? "Listen to ".concat(linkText !== null && linkText !== void 0 ? linkText : 'audio') : "Watch ".concat(linkText !== null && linkText !== void 0 ? linkText : 'video'),
        role: "button",
        children: /*#__PURE__*/ _jsxs(View, {
            "aria-hidden": true,
            children: [
                /*#__PURE__*/ _jsx(FullscreenMediaPlayer, {
                    previewAspectRatio: 1,
                    mediaAspectRatio: null,
                    uri: uri,
                    ref: player,
                    initialPositionMillis: initialPositionMillis !== null && initialPositionMillis !== void 0 ? initialPositionMillis : 5000,
                    caption: caption,
                    borderRadius: 10
                }),
                /*#__PURE__*/ _jsx(Button, {
                    text: linkText !== null && linkText !== void 0 ? linkText : isAudio ? 'Play audio' : 'Play video',
                    variant: "text",
                    alignSelf: "center",
                    onPress: play
                })
            ]
        })
    });
}
function ChatImage(param) {
    var uri = param.uri, linkText = param.linkText, caption = param.caption;
    var _useState = _sliced_to_array(useState(false), 2), fullscreen = _useState[0], setFullscreen = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    var insets = useSafeAreaInsets();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(TouchableOpacity, {
                onPress: function() {
                    return setFullscreen(true);
                },
                "aria-label": linkText !== null && linkText !== void 0 ? linkText : 'Show image',
                role: "button",
                children: [
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: '100%',
                            aspectRatio: 1
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Image, {
                                source: {
                                    uri: uri.startsWith('https://storage.googleapis.com') ? getResizedImageUrl(uri, {
                                        width: MAX_WIDTH
                                    }) : uri
                                },
                                onError: function(e) {
                                    Sentry.withScope(function(scope) {
                                        scope.setExtras({
                                            error: e.nativeEvent
                                        });
                                        Sentry.captureException('ChatAsset image load error');
                                    });
                                },
                                onLoadEnd: function() {
                                    return setLoading(false);
                                },
                                resizeMode: "cover",
                                style: {
                                    height: '100%',
                                    width: '100%',
                                    borderRadius: 10
                                }
                            }),
                            loading ? /*#__PURE__*/ _jsx(ActivityIndicator, {
                                style: StyleSheet.absoluteFillObject
                            }) : null
                        ]
                    }),
                    linkText === '' ? null : /*#__PURE__*/ _jsx(Button, {
                        text: linkText !== null && linkText !== void 0 ? linkText : 'Show image',
                        variant: "text",
                        alignSelf: "center",
                        onPress: function() {
                            return setFullscreen(true);
                        }
                    })
                ]
            }),
            fullscreen ? /*#__PURE__*/ _jsx(Modal, {
                visible: fullscreen,
                transparent: true,
                children: /*#__PURE__*/ _jsx(ImageViewer, {
                    useNativeDriver: true,
                    backgroundColor: "rgba(0,0,0,0.95)",
                    enableSwipeDown: true,
                    renderIndicator: function() {
                        return /*#__PURE__*/ _jsx(View, {});
                    },
                    footerContainerStyle: {
                        width: '100%'
                    },
                    renderHeader: function() {
                        return /*#__PURE__*/ _jsx(View, {
                            style: {
                                position: 'absolute',
                                top: 0,
                                width: '100%',
                                backgroundColor: 'rgba(0,0,0,0.3)',
                                zIndex: 1,
                                paddingTop: insets.top,
                                paddingBottom: insets.bottom
                            },
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    padding: 10,
                                    alignItems: 'flex-start'
                                },
                                children: /*#__PURE__*/ _jsx(Icon, {
                                    name: "close",
                                    onPress: function() {
                                        return setFullscreen(false);
                                    },
                                    color: "white",
                                    "aria-label": "Exit fullscreen"
                                })
                            })
                        });
                    },
                    renderFooter: caption ? function() {
                        return /*#__PURE__*/ _jsx(ScrollView, {
                            style: {
                                maxHeight: 150,
                                backgroundColor: 'rgba(0,0,0,0.6)'
                            },
                            contentContainerStyle: {
                                padding: 10,
                                paddingBottom: insets.bottom + 10
                            },
                            children: typeof caption === 'string' ? /*#__PURE__*/ _jsx(Text, {
                                text: caption,
                                color: "white",
                                textAlign: "center",
                                weight: "semibold"
                            }) : caption
                        });
                    } : undefined,
                    imageUrls: [
                        {
                            url: uri
                        }
                    ],
                    loadingRender: function() {
                        return /*#__PURE__*/ _jsx(ActivityIndicator, {});
                    },
                    onCancel: function() {
                        return setFullscreen(false);
                    },
                    onClick: function() {
                        return setFullscreen(false);
                    }
                })
            }) : null
        ]
    });
}
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-57}
 */ export function getAccessibilityTextForChatAsset(props) {
    var _classifyAsset = classifyAsset(props.uri), isVideo = _classifyAsset.isVideo, isAudio = _classifyAsset.isAudio, isImage = _classifyAsset.isImage;
    if (isVideo) {
        var _props_linkText;
        return "A video: ".concat((_props_linkText = props.linkText) !== null && _props_linkText !== void 0 ? _props_linkText : '');
    } else if (isAudio) {
        var _props_linkText1;
        return "An audio recording: ".concat((_props_linkText1 = props.linkText) !== null && _props_linkText1 !== void 0 ? _props_linkText1 : '');
    } else if (isImage) {
        return "An image";
    }
    return 'An asset';
}
/**
 * Renders different types of chat assets based on the provided URI. It takes
 * various props such as caption, initialPositionMillis, linkText. The function
 * determines if the asset is a video, audio, or image using the classifyAsset
 * utility. It then conditionally renders the appropriate component (ChatVideo
 * for video or audio, ChatImage for images).
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-57}
 */ export function ChatAsset(param) {
    var caption = param.caption, initialPositionMillis = param.initialPositionMillis, linkText = param.linkText, _param_padding = param.padding, padding = _param_padding === void 0 ? true : _param_padding, uri = param.uri;
    var _classifyAsset = classifyAsset(uri), isVideo = _classifyAsset.isVideo, isAudio = _classifyAsset.isAudio, isImage = _classifyAsset.isImage;
    return /*#__PURE__*/ _jsx(View, {
        style: {
            padding: padding ? 10 : 0
        },
        children: /*#__PURE__*/ _jsxs(View, {
            style: {
                maxWidth: MAX_WIDTH
            },
            children: [
                isVideo ? /*#__PURE__*/ _jsx(ChatVideo, {
                    uri: uri,
                    linkText: linkText,
                    initialPositionMillis: initialPositionMillis,
                    caption: caption
                }) : null,
                isAudio ? /*#__PURE__*/ _jsx(ChatVideo, {
                    uri: uri,
                    linkText: linkText,
                    isAudio: true,
                    caption: caption
                }) : null,
                isImage ? /*#__PURE__*/ _jsx(ChatImage, {
                    uri: uri,
                    linkText: linkText,
                    caption: caption
                }) : null
            ]
        })
    });
}
